import { render, staticRenderFns } from "./video-show2.vue?vue&type=template&id=ce284b2a&scoped=true"
import script from "./video-show2.vue?vue&type=script&lang=js"
export * from "./video-show2.vue?vue&type=script&lang=js"
import style0 from "./video-show2.vue?vue&type=style&index=0&id=ce284b2a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce284b2a",
  null
  
)

export default component.exports